module.exports = __webpack_public_path__ + "static/grist-mill-logo-b3c42f01d1d656ac5a4a13abb5690272.jpg";